(function () {
  var API_BASE = 'https://nmgshop.duckdns.org/special-deal-med1-vet-clinic';
  var STORAGE_KEY = 'med1_ty_code';
  var ALLOWED_REFERRER = /^https:\/\/(www\.)?nmg-shop\.com\//i;

  var codeEl = document.querySelector('[data-ty-code]');
  var copyBtn = document.querySelector('[data-ty-copy]');
  var codeState = document.querySelector('[data-ty-code-state]');
  var blockedState = document.querySelector('[data-ty-blocked]');
  var cardEl = document.querySelector('[data-ty-card]');
  var heroDefault = document.querySelector('[data-ty-hero-default]');
  var heroBlocked = document.querySelector('[data-ty-hero-blocked]');
  var heroSoldout = document.querySelector('[data-ty-hero-soldout]');
  if (!codeEl) return;

  function showCode(code) {
    codeEl.textContent = code;
    if (copyBtn) copyBtn.disabled = false;
  }

  function showBlocked() {
    if (codeState) codeState.hidden = true;
    if (blockedState) blockedState.hidden = false;
    if (heroDefault) heroDefault.hidden = true;
    if (heroBlocked) heroBlocked.hidden = false;
    window.__tyBlocked = true;
  }

  function showSoldout() {
    if (cardEl) cardEl.hidden = true;
    if (heroDefault) heroDefault.hidden = true;
    if (heroSoldout) heroSoldout.hidden = false;
    window.__tyBlocked = true;
  }

  if (copyBtn) copyBtn.disabled = true;

  var saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}

  if (saved) {
    showCode(saved);
  } else if (!ALLOWED_REFERRER.test(document.referrer || '')) {
    // No sign this visit came from the survey flow on nmg-shop.com —
    // don't burn a real code on a bot crawl, shared link, or another device.
    showBlocked();
  } else {
    fetch(API_BASE + '/get-code')
      .then(function (res) {
        if (!res.ok) throw new Error('no_codes_left');
        return res.json();
      })
      .then(function (data) {
        showCode(data.code);
        try { localStorage.setItem(STORAGE_KEY, data.code); } catch (e) {}
      })
      .catch(showSoldout);
  }
})();

(function () {
  var copyBtn = document.querySelector('[data-ty-copy]');
  if (!copyBtn) return;
  var codeEl = document.querySelector('[data-ty-code]');
  var defaultLabel = copyBtn.innerHTML;

  copyBtn.addEventListener('click', function () {
    var text = codeEl ? codeEl.textContent.trim() : '';
    if (!text) return;
    var done = function () {
      copyBtn.classList.add('is-copied');
      copyBtn.innerHTML = copyBtn.getAttribute('data-copied-label') || 'คัดลอกแล้ว ✓';
      setTimeout(function () {
        copyBtn.classList.remove('is-copied');
        copyBtn.innerHTML = defaultLabel;
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(done);
    } else {
      var tmp = document.createElement('textarea');
      tmp.value = text;
      tmp.style.position = 'fixed';
      tmp.style.opacity = '0';
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(tmp);
      done();
    }
  });
})();

(function () {
  var openBtns = document.querySelectorAll('[data-ty-howto-open]');
  var modal = document.getElementById('tyHowtoModal');
  if (!openBtns.length || !modal) return;
  var closeBtn = modal.querySelector('[data-ty-howto-close]');

  function open() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });
})();

(function () {
  var zoomBtns = document.querySelectorAll('[data-ty-zoom]');
  var lightbox = document.getElementById('tyLightbox');
  var lightboxImg = document.getElementById('tyLightboxImg');
  var closeBtn = document.getElementById('tyLightboxClose');
  if (!zoomBtns.length || !lightbox || !lightboxImg) return;

  function open(src, alt) {
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    lightbox.hidden = true;
    lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  zoomBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = btn.parentElement.querySelector('img');
      if (img) open(img.src, img.alt);
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lightbox.hidden) close();
  });
})();

(function () {
  if (window.__tyBlocked) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var colors = ['#4fb3e8', '#7dd3c0', '#f6b93b', '#ff7eb6', '#8b7de8'];
  var count = window.innerWidth < 560 ? 70 : 130;

  var canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.inset = '0';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = '9999';
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var dpr = window.devicePixelRatio || 1;

  function resize() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();

  var pieces = [];
  for (var i = 0; i < count; i++) {
    pieces.push({
      x: Math.random() * window.innerWidth,
      y: -20 - Math.random() * window.innerHeight * 0.5,
      w: 6 + Math.random() * 5,
      h: 9 + Math.random() * 6,
      color: colors[Math.floor(Math.random() * colors.length)],
      rot: Math.random() * 360,
      rotSpeed: (Math.random() - 0.5) * 10,
      vy: 2.2 + Math.random() * 2.4,
      vx: (Math.random() - 0.5) * 1.6,
      drift: Math.random() * Math.PI * 2
    });
  }

  var start = null;
  var duration = 3400;
  var rafId;

  function frame(ts) {
    if (!start) start = ts;
    var elapsed = ts - start;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    pieces.forEach(function (p) {
      p.y += p.vy;
      p.x += p.vx + Math.sin((elapsed / 400) + p.drift) * 0.6;
      p.rot += p.rotSpeed;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rot * Math.PI) / 180);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    });

    if (elapsed < duration) {
      rafId = requestAnimationFrame(frame);
    } else {
      cancelAnimationFrame(rafId);
      canvas.remove();
    }
  }

  window.addEventListener('resize', resize, { passive: true });
  rafId = requestAnimationFrame(frame);
})();
